// jQuery(document).ready(function() {
//     if (is_dev) {
//         finish_appointment(298);
//     }
// })

function finish_appointment(appointmentId) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: `/calendar/getFinishWizard/${appointmentId}`,
        onOpen: function(elm, popup) {
            const screens = {
                presentPassed: elm.find('.scroll-screen.present-passed'),
                refresherCourses: elm.find('.scroll-screen.refresher-courses'),
                generateDocument: elm.find('.scroll-screen.generate-document'),
                appointmentStatus: elm.find('.scroll-screen.appointment-status'),
                overview: elm.find('.scroll-screen.overview'),
                nextMove: elm.find('.scroll-screen.next-move'),
            }

            let debouncedPresentPassedReaction;

            const getPassedContacts = () => {
                const contactIds = [];
                screens.presentPassed.find('table.present-students-table').find('tr[data-id]').each(function() {
                    if (!contactIds.includes($(this).attr('data-id'))) {
                        contactIds.push($(this).attr('data-id'));
                    }
                });
                const passedContacts = [];
                contactIds.forEach((contactId) => {
                    let allChecked = true;
                    screens.presentPassed.find('table.present-students-table').find(`tr[data-id=${contactId}]`).each(function() {
                        const numberOfPositiveResults = $(this).find('select:not([disabled]):has(option[value="1"]:selected)').length;
                        if (numberOfPositiveResults < 2) {
                            allChecked = false;
                        }
                    });
                    if (allChecked) {
                        passedContacts.push(contactId);
                    }
                });
                return passedContacts;
            }

            // Next button disable / enable in first screen upon checking unchecking a contact
            screens.presentPassed.find('.present-students-table').unbind('onReload').bind('onReload', () => {
                screens.presentPassed.find('select[name^="present_students"], select[name^="passed_students"]').unbind('change.nextButtonToggle').bind('change.nextButtonToggle', function() {
                    if (debouncedPresentPassedReaction) {
                        debouncedPresentPassedReaction.cancel();
                    }
                    debouncedPresentPassedReaction = _.debounce(() => {
                        screens.presentPassed.find('button')[0].disabled = screens.presentPassed
                            .find('select[name^="present_students"]:has(option[value=""]:selected), select[name^="passed_students"]:has(option[value=""]:selected)')
                            .length > 0;
                    }, 100);
                    debouncedPresentPassedReaction();
                });
                screens.presentPassed.find('tr[data-id] select[name^="present_students"]:first').trigger('change');
            });
            elm.find('[data-present-passed-logic-wrapper]').each(function() {
                initPresencePassLogic($(this)[0]);
            });

            // All present + passed students get presented in the refreshers part
            const suggestRefreshers = async function() {
                const passedContacts = getPassedContacts();

                const suggestions = Object.values(await $.getJSON(`/calendar/getStudentRefresherSuggestions/${appointmentId}`, { students: passedContacts }));

                const refresherCheckTable = screens.refresherCourses.find('.refresher-check-table');
                refresherCheckTable.find('tbody tr:not(:nth-child(1))').remove();
                refresherCheckTable.find('tbody tr').hide();
                suggestions.forEach((suggestion, index) => {
                    let tr = refresherCheckTable.find(`tbody tr:nth-child(${index + 1})`);
                    if (tr.length === 0) {
                        tr = refresherCheckTable.find(`tbody tr:nth-child(1)`).clone();
                        refresherCheckTable.find('tbody').append(tr);
                    }
                    tr.show();

                    const inputNamePrefix = (name) => `refreshers[${index}][${name}]`;

                    // Set contact column
                    const studentLink = $('<a />');
                    studentLink.click(function(e) {
                        e.preventDefault();
                        view_contact(suggestion.contact.id, suggestRefreshers);
                        return false;
                    });
                    studentLink.html(suggestion.contact.messageName);
                    let companyLink = '';
                    if (suggestion.contact.company) {
                        companyLink = $('<a />');
                        companyLink.html(` (${suggestion.contact.company.name})`);
                        companyLink.click(function(e) {
                            e.preventDefault();
                            view_company(suggestion.contact.company.id, suggestRefreshers);
                            return false;
                        });
                    }
                    tr.find('.student-name').html(studentLink);
                    tr.find('.student-name').append(companyLink);

                    // Set contact id
                    const contactIdInput = $('<input type="hidden" />')
                    contactIdInput.val(suggestion.contact.id);
                    contactIdInput.attr('name', inputNamePrefix('contact_id'));
                    tr.find('.student-name').append(contactIdInput);

                    // Set the refresher select box
                    const select = tr.find('.refresher-info select');
                    select.find('option:not([value="-1"]):not([value="0"])').remove();
                    select.unbind('change').change(function() {
                        const v = $(this).val();
                        const spyGlass = $(this).next();
                        spyGlass.toggle(v !== '-1' && v !== '0');
                        spyGlass.unbind('click').click(function(e) {
                            e.preventDefault();
                            if (v === '-1' || v === '0') {
                                return false;
                            }

                            view_contact_refresher(v, suggestRefreshers)

                            return false;
                        });

                        const refresherActive = v !== '0';
                        tr.find('.refresher-active').toggle(refresherActive);
                        tr.find('.refresher-inactive').toggle(!refresherActive);
                    });
                    let suggestionRefreshers = [];
                    if (suggestion.refreshers) {
                        suggestionRefreshers = suggestion.refreshers;
                    }
                    select.append(suggestionRefreshers.map((refresher) => {
                        const option = $('<option />');
                        option.attr('value', refresher.id);
                        option.html(`${refresher.course.description} (${moment(refresher.expires_at).format('DD-MM-YYYY')})`);
                        return option;
                    }));
                    select.val(suggestion.refresher ? suggestion.refresher.id : '-1');
                    select.trigger('change');
                    select.attr('name', inputNamePrefix('contact_refresher_course_id'));

                    // Set the new course
                    const courseSelector = tr.find('td.course select');
                    courseSelector.attr('data-uid', get_unique_id('data-uid'))
                    courseSelector.removeClass('has-special-selector');
                    // courseSelector.courseSelector(suggestion.refresher ? suggestion.refresher.course_id : (suggestion.refresherCourse ? suggestion.refresherCourse.id : '-1'));
                    courseSelector.courseSelector(suggestion.refresherCourse ? suggestion.refresherCourse.id : '-1');
                    courseSelector.attr('name', inputNamePrefix('course_id'));

                    // Set the new expiration date
                    const expirationDateInput = tr.find('.new-expiration-date input');
                    expirationDateInput.val(moment(suggestion.expirationDate).format('DD-MM-YYYY'));
                    expirationDateInput.attr('name', inputNamePrefix('expiration_date'));
                });
            };
            screens.refresherCourses.bind('beforeScroll', suggestRefreshers);

            // HOK Logic
            screens.appointmentStatus.bind('beforeScroll', async () => {
                const hokCheckbox = screens.appointmentStatus.find('input#pass_to_hok');
                if (hokCheckbox.length === 0) {
                    return;
                }
                const hokErrorsBox = screens.appointmentStatus.find('.hok-errors');
                const nextButton = screens.appointmentStatus.find('.next-button');
                const validateHok = async () => {

                    if (!hokCheckbox.is(':checked')) {
                        nextButton[0].disabled = false;
                        hokErrorsBox.hide();
                        return;
                    }
                    // Validate contacts and teachers
                    nextButton[0].disabled = true;
                    const students = getPassedContacts();

                    const result = await $.get(`/hok/validateAppointment/${appointmentId}`, { students });
                    const isValid = result.success;
                    hokErrorsBox.toggle(!isValid);
                    if (result.success === false) {
                        hokErrorsBox.html(result.errors.join('<br>'));
                    }

                    nextButton[0].disabled = !isValid;
                }
                await validateHok();
                hokCheckbox.unbind('change').change(validateHok);
            });

            screens.overview.bind('beforeScroll', async () => {
                const data = elm.find('form').serializeJSON();

                // Remove the refreshers that have contact_refresher_course_id = 0
                data.refreshers = Object.values(data.refreshers).filter((refresher) => {
                    const intId = parseInt(refresher.contact_refresher_course_id);
                    return !isNaN(intId) && intId !== 0;
                });

                const hokEnabled = data.pass_to_hok === '1';

                // Update the overview page

                // Get all students
                let allContacts = [];
                screens.presentPassed.find('table.present-students-table').each(function() {
                    $(this).getThisElementsData().forEach(function(contact) {
                        if (!allContacts.find((existingContact) => existingContact.id === contact.id)) {
                            // Get whether contact was present all time
                            let allChecked = true;
                            screens.presentPassed.find('table.present-students-table').find(`tr[data-id=${contact.id}]:visible`).each(function() {
                                const numberOfPositiveResults = $(this).find('select:has(option[value="1"]:selected)').length;
                                if (numberOfPositiveResults < 2) {
                                    allChecked = false;
                                }
                            });
                            contact.presentAndPassed = allChecked;

                            // Refreshers
                            if (data.refreshers) {
                                contact.refreshers = Object.values(data.refreshers).filter((refresher) => {
                                    return parseInt(refresher.contact_id) === parseInt(contact.id);
                                });
                            }

                            allContacts.push(contact);
                        }
                    })
                });
                allContacts = _.orderBy(allContacts, ['last_name', 'first_name'], ['asc', 'asc']);

                // Update the students overview
                (() => {

                    const failedStudents = allContacts.filter((contact) => contact.presentAndPassed === false);
                    const passedStudents = allContacts.filter((contact) => contact.presentAndPassed === true)

                    screens.overview.find('.has-failed-students').toggle(failedStudents.length > 0);

                    screens.overview.find('.tag-input-failed_students').setTags(failedStudents.map((student) => student.messageName));
                    screens.overview.find('.tag-input-all_passed_students').setTags(passedStudents.map((student) => student.messageName));

                    // Hok logic
                    screens.overview.find('.hok-enabled').toggle(hokEnabled);
                    screens.overview.find('.hok-disabled').toggle(!hokEnabled);
                })();

                // Update the refreshers overview
                await (async () => {
                    let refreshers = [];
                    if (data.refreshers) {
                        const existingRefresherIds = Object.values(data.refreshers).map((refresher) => refresher.contact_refresher_course_id).filter((id) => parseInt(id) > 0);
                        const existingRefreshers = await $.getJSON(`/courses/refreshers/fetch`, {id: existingRefresherIds});

                        const courses = _.uniqBy(existingRefreshers.map((refresher) => refresher.course), 'id');

                        const foundCourses = existingRefreshers.map((refresher) => refresher.course_id);
                        const courseIds = _.difference(Object.values(data.refreshers).map((refresher) => refresher.course_id).map((id) => parseInt(id)), foundCourses);
                        if (courseIds.length > 0) {
                            const otherCourses = await $.get('/courses/fetch', {id: courseIds});
                            otherCourses.forEach((course) => {
                                courses.push(course);
                            })
                        }
                        refreshers = Object.values(data.refreshers).map((domRefresher) => {
                            const refresher = domRefresher;
                            refresher.contact = allContacts.find((contact) => parseInt(contact.id) === parseInt(domRefresher.contact_id));
                            const existing = existingRefreshers.find((refresher) => refresher.id === parseInt(domRefresher.contact_refresher_course_id));
                            refresher.action = existing ? 'update' : 'create';
                            refresher.original = existing;
                            refresher.course = courses.find((course) => course.id === parseInt(domRefresher.course_id));
                            return refresher;
                        });
                    }

                    screens.overview.find('.no-refreshers').toggle(refreshers.length === 0);
                    screens.overview.find('.has-refreshers').toggle(refreshers.length > 0);

                    const wrapper = screens.overview.find('.refresher-students');
                    wrapper.children(':not(:nth-child(1))').remove();
                    refreshers.forEach((refresher, index) => {
                        let elm = wrapper.children(`:nth-child(${index + 1})`);
                        if (elm.length === 0) {
                            elm = wrapper.children(`:nth-child(1)`).clone();
                            wrapper.append(elm);
                        }
                        const contact = refresher.contact;

                        elm.find('h4').html(contact.messageName);

                        const action = refresher.action;
                        elm.find('.create-refresher').toggle(action === 'create');
                        elm.find('.update-different-refresher').toggle(action === 'update' && parseInt(refresher.course_id) !== refresher.original.course_id);
                        elm.find('.update-same-refresher').toggle(action === 'update' && parseInt(refresher.course_id) === refresher.original.course_id);

                        elm.find('.refresher-expires-at').html(refresher.expiration_date);
                        elm.find('.refresher-description').html(refresher.course.description);
                        elm.find('.original-refresher-description').html((refresher.original && refresher.original.course) ? refresher.original.course.description : '');
                    })
                })();

                // Update the documents overview
                (() => {
                    let documentLayouts = [];
                    if (data.document_layouts) {
                        documentLayouts = data.document_layouts.map(function(layoutId) {
                            const name = screens.generateDocument.find(`input[value=${layoutId}]`).parent()[0].innerText.trim();
                            return {
                                id: parseInt(layoutId),
                                name,
                            }
                        })
                    }

                    screens.overview.find('.no-documents').toggle(documentLayouts.length === 0);
                    screens.overview.find('.has-documents').toggle(documentLayouts.length > 0);

                    screens.overview.find('.documents-list').html(_.sortBy(documentLayouts, 'name').map((layout) => layout.name).join(', '));
                })();

                // Update the status overview
                (() => {
                    const updateStatus = data.update_status === '1';
                    screens.overview.find('.no-change').toggle(!updateStatus);
                    screens.overview.find('.new-status').toggle(updateStatus);
                })();

                // Disable the certificates buttons for HOK courses
                elm.find('.print-certificates-button').toggle(!hokEnabled);
                elm.find('.send-certificates-button').toggle(!hokEnabled);
            })

            // Save all the selected changes
            elm.find('form').ajaxFormSubmit(function() {
                reload_location_if_needed(false, undefined, false);
                ajax_popup_scroll_to_next_screen();
                squde_reload_for_flashes();
                screens.nextMove.find('button:not(.close-reveal-modal)').click(function(e) {
                    e.preventDefault();
                    popup.close();
                })
            });
        }
    });
    return false;
}
